module.exports = __webpack_public_path__ + "img/fondo-banner-principal.faddb406.svg";